import { addDatapointConfig } from 'owa-analytics-actions';
import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchInputFocused = action(
    'ON_SEARCH_INPUT_FOCUSED_NEXT',
    (scenarioId: SearchScenarioId, isUsing3S: boolean) =>
        addDatapointConfig({ name: 'ON_SEARCH_INPUT_FOCUSED' }, { scenarioId, isUsing3S })
);

export default onSearchInputFocused;
